
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tutorials/[module]/[lesson]/embed",
      function () {
        return require("private-next-pages/tutorials/[module]/[lesson]/embed.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tutorials/[module]/[lesson]/embed"])
      });
    }
  